<section id="most-popular-section" class="feat-pro2" style="min-height: 651px">
  <div class="container px-0 pt-4">
    <div class="row py-4 w-100">
      <div class="col-md-12 d-flex justify-content-center">
        <h2 class="p-2 font-weight-bold with-line section-title">Categorías favoritas</h2>
      </div>
    </div>
    <div class="d-flex flex-column align-items-center mx-3 mx-md-0">
      <div class="d-flex flex-column flex-md-row post-container">
        <div class="post-60 market-bg-color-blue d-flex flex-column align-items-center align-items-lg-start flex-lg-row justify-content-between align-items-start py-lg-4 pl-lg-4 mr-lg-3 mr-xl-5 position-relative mb-4 mb-md-0"
             style="border-radius:15px">
          <div class="d-flex flex-column align-items-lg-start align-items-center text-center text-lg-left mt-5">
            <span class="text-white products-title" style="white-space: nowrap">COMBOS</span>
            <span style="color: #031841" class="mt-3 products-subtitle font-weight-bold"
                  >Variedad de<br>productos por<br>un solo precio</span>
            <div class="position-absolute pb-2 w-100 d-flex justify-content-center justify-content-lg-start cta" style="bottom: 20%;">
              <button routerLink="tienda-online-cuba/combos"
                      class="btn bg-white px-2 py-2 py-xl-3 font-weight-bold OpenSans rounded-pill w-75 position-relative main-button"
                      style="color: #0C8EFE">
                Comprar Ahora
              </button>
            </div>
          </div>
          <img class="d-block d-md-none align-self-end" width="320px" src="assets/market/banner-combos.png" alt="Combos">
          <img class="d-none d-md-block d-lg-none align-self-end" width="280px" src="assets/market/banner-combos.png" alt="Combos">
          <img class="d-none d-lg-block d-xl-none align-self-center" width="240px" src="assets/market/banner-combos.png" alt="Combos">
          <img class="d-none d-xl-block" width="400px" src="assets/market/banner-combos.png" alt="Combos">
        </div>
        <div class="post-30 d-flex flex-md-column justify-content-between">
          <div class="d-flex market-bg-color-green flex-column-reverse align-items-center flex-md-row p-2 py-md-4 pl-md-4 pr-md-0 m-1"
               style="border-radius:15px">
            <div class="pb-2 w-100 d-md-none d-flex justify-content-center cta mt-2">
              <button routerLink="tienda-online-cuba/aseo"
                      class="btn bg-white px-2 py-1 font-weight-bold OpenSans rounded-pill position-relative"
                      style="color: #48C2AE; font-size: 13px">
                Ver Productos
              </button>
            </div>
            <img class="d-block d-md-none" width="117" src="assets/market/banner-aseo.png" alt="Aseo y Belleza">

            <div class="d-flex flex-column position-relative">
              <span class="h2 text-center text-md-left text-white font-weight-bold" >Aseo</span>
              <span style="color: #013C33" class="mt-md-2 text-center text-md-left products-subtitle-2 mb-2 font-weight-bold" >Personal y del hogar<br> en el mismo lugar.</span>
              <div class="pb-2 w-100 d-none d-md-flex justify-content-start cta mt-4" style="bottom: -40%;">
                <button routerLink="tienda-online-cuba/aseo"
                        class="btn bg-white px-2 py-1 font-weight-bold OpenSans rounded-pill position-relative"
                        style="color: #48C2AE; font-size: 16px;width:190px">
                  Ver productos
                </button>
              </div>
            </div>
            <img class="d-none d-md-block ml-auto" width="150" src="assets/market/banner-aseo.png" alt="Aseo y Belleza">

          </div>
          <div class="d-flex market-bg-color-red flex-column-reverse align-items-center flex-md-row justify-content-center p-2 py-md-4 pl-md-4 pr-md-0 m-1"
               style="border-radius:15px">
            <div class="d-flex d-md-none pb-2 w-100 d-flex justify-content-center cta mt-2">
              <button routerLink="tienda-online-cuba/piezas-motos-carros"
                      class="btn bg-white px-2 py-1 font-weight-bold OpenSans rounded-pill position-relative"
                      style="color: #FC8F8F; font-size: 13px;">
                Ver Productos
              </button>
            </div>
            <img class="d-block d-md-none" width="77" src="assets/market/banner-automotriz.png" alt="Automotriz">

            <div class="d-flex flex-column position-relative" style="flex: 1 1">
              <span class="h2 text-center text-white text-md-left" >Automotriz</span>
              <span style="color: #7B0E0E" class="mt-md-2 text-center text-md-left products-subtitle-2 mb-2 font-weight-bold">Piezas, gomas, repuestos <br> y mucho más.</span>
              <div class="d-none d-md-flex pb-2 w-100 justify-content-center justify-content-md-start cta mt-4" style="bottom: -40%;">
                <button routerLink="tienda-online-cuba/piezas-motos-carros"
                        class="btn bg-white px-2 py-1 font-weight-bold OpenSans rounded-pill position-relative"
                        style="color: #FC8F8F; font-size: 16px;width:190px">
                  Ver Productos
                </button>
              </div>
            </div>
            <img class="d-none d-md-block" width="150" src="assets/market/banner-automotriz.png" alt="Automotriz">

          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<ng-template #snippet>
  <div class="backdrop" style="border-radius: 25px">
    <div class="snippet" data-title="dot-pulse">
      <div class="stage">
        <div class="dot-pulse"></div>
      </div>
    </div>
  </div>
</ng-template>
